import { SET_PREVIEW_MEDIA_SOURCE, SET_MEDIA_ROW_OBJECT } from '../constants/actionTypes';
import { getBody } from './helpers';

export const setPreviewMediaSource = mediaPreview => ({
    type: SET_PREVIEW_MEDIA_SOURCE,
    mediaPreview: mediaPreview
});

export const setMediaRowObject = mediaRowObject => ({
    type: SET_MEDIA_ROW_OBJECT,
    mediaRowObject: mediaRowObject
});



// WEBPACK FOOTER //
// ./src/actions/previewMedia.js